import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=4f9ef8de&scoped=true&lang=pug&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=4f9ef8de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9ef8de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f9ef8de')) {
      api.createRecord('4f9ef8de', component.options)
    } else {
      api.reload('4f9ef8de', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=4f9ef8de&scoped=true&lang=pug&", function () {
      api.rerender('4f9ef8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/record/edit.vue"
export default component.exports